import gql from 'graphql-tag'
import client from '../../stores/apollo'
import normalize from './normalize'
import { FloorMapSpaceFragment, SpaceAssignmentFragment } from '../fragments'
import { IFloorMapSpace, FloorMapSpaces, RawViewFilters } from '../types'

interface IPayload {
  data: {
    map: {
      spaces: IFloorMapSpace[]
    }
    viewer: { viewFilters: RawViewFilters }
  }
}

type ReturnType = {
  spaces: FloorMapSpaces
  viewFilters: RawViewFilters
}
export default function spaceAssignments(
  floorId: string,
  apId: string | null
): Promise<ReturnType> {
  const variables = { id: floorId, assignmentPlanId: apId }

  return client.gql.query({ query, variables }).then(
    ({
      data: {
        map: { spaces },
        viewer: { viewFilters },
      },
    }: IPayload) => ({
      spaces: normalize(spaces),
      viewFilters,
    })
  )
}

const query = gql`
  query SpaceAssignments($id: ID!, $assignmentPlanId: ID) {
    viewer {
      viewFilters {
        name
        objectType
        filters {
          key
          value
          visible
          displayName
        }
      }
    }
    map: node(id: $id) {
      ... on Floor {
        spaces {
          ...FloorMapSpaceFragment
          spaceAssignment(assignmentPlanId: $assignmentPlanId) {
            ...SpaceAssignmentFragment
          }
        }
      }
    }
  }
  ${FloorMapSpaceFragment}
  ${SpaceAssignmentFragment}
`
